import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContent } from "@/content/ContentContext";

const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Errore";
};

const Field = ({ label, ...props }) => (
  <label className="block">
    <span className="text-[11px] uppercase tracking-[0.2em] text-anthracite/60">{label}</span>
    <input
      {...props}
      className="mt-2 w-full bg-ivory border border-sand px-4 py-3 text-base outline-none focus:border-bordeaux transition-colors"
    />
  </label>
);

const AdminPage = () => {
  const { admin, login, logout, changePassword, setEditMode } = useContent();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [pw, setPw] = useState({ current: "", next: "" });
  const [pwMsg, setPwMsg] = useState("");

  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  const submitPw = async (e) => {
    e.preventDefault();
    setPwMsg("");
    try {
      await changePassword(pw.current, pw.next);
      setPwMsg("Password aggiornata.");
      setPw({ current: "", next: "" });
    } catch (err) {
      setPwMsg(formatErr(err));
    }
  };

  return (
    <main className="pt-28 md:pt-40 pb-24 min-h-[100svh]" data-testid="admin-page">
      <div className="max-w-md mx-auto px-5">
        <p className="eyebrow text-olive mb-7">Area riservata</p>
        {!admin ? (
          <>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight" data-testid="admin-login-title">
              Accedi per modificare il sito
            </h1>
            <form onSubmit={submit} className="mt-10 space-y-5" data-testid="admin-login-form">
              <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input" />
              <Field label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input" />
              {error && (
                <p className="text-sm text-bordeaux" data-testid="admin-login-error">
                  {error}
                </p>
              )}
              <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit">
                {busy ? "Accesso…" : "Entra"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight" data-testid="admin-welcome-title">
              Ciao, sei dentro.
            </h1>
            <p className="mt-5 text-base font-light text-anthracite/75 leading-relaxed">
              Attiva la modalità modifica e clicca su qualsiasi testo o foto del sito per cambiarlo. Le modifiche si
              salvano subito e sono visibili a tutti.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <button
                onClick={() => {
                  setEditMode(true);
                  navigate("/");
                }}
                className="btn-primary"
                data-testid="admin-start-editing"
              >
                Vai al sito e modifica
              </button>
              <button onClick={logout} className="btn-outline" data-testid="admin-logout">
                Esci
              </button>
            </div>

            <form onSubmit={submitPw} className="mt-16 space-y-5 border-t border-sand pt-10" data-testid="admin-password-form">
              <p className="font-serif text-2xl">Cambia password</p>
              <Field label="Password attuale" type="password" value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} required data-testid="admin-pw-current" />
              <Field label="Nuova password (min. 8 caratteri)" type="password" value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} required data-testid="admin-pw-new" />
              {pwMsg && <p className="text-sm text-olive" data-testid="admin-pw-msg">{pwMsg}</p>}
              <button type="submit" className="btn-outline" data-testid="admin-pw-submit">
                Aggiorna password
              </button>
            </form>
          </>
        )}
      </div>
    </main>
  );
};

export default AdminPage;
